export const summaryBarScopes = {
  campaignType: {
    id: 'campaign-type',
  },
  campaign: {
    id: 'campaign',
  },
  adGroup: {
    id: 'ad-group',
  },
  accounts: {
    id: 'accounts',
  },
  ad: {
    id: 'ad',
  },
};
